// import React, { useEffect, useState } from "react";

// import axios from "axios";

// import "../CSS/IssueForm.css";
// import "../CSS/Message.css";

// import IssueLoaderButton from "./pageLoaders/IssueLoaderButton";
// import PageLoader from "./pageLoaders/PageLoader";

// const IssueForm = ({
//   onSubmit,
//   setShowForm,
//   setTicketId,
//   ticketId,
//   loading,
//   setLoading,
//   widgetConfigs,
//   setupDetails,
// }) => {
//   const [formData, setFormData] = useState({});
//   const [formConfigs, setFormConfigs] = useState([
//     {
//       validation: {
//         pattern: "",
//         errorMessage: "",
//       },
//       ui: {
//         colSpan: 24,
//       },
//       fieldType: "text",
//       label: "Subject",
//       name: "subject",
//       required: true,
//       options: [],
//       order: 1,
//       _id: 1,
//     },
//     {
//       validation: {
//         pattern: "",
//         errorMessage: "",
//       },
//       ui: {
//         colSpan: 24,
//       },
//       fieldType: "textarea",
//       label: "Description",
//       name: "description",
//       required: true,
//       options: [],
//       order: 1,
//       _id: 2,
//     },
//   ]);
//   const [isFormConfigLoading, setIsFormConfigLoading] = useState(false);
//   const [customerDetails, setCustomerDetails] = useState(null);

//   console.log({ formConfigs });

//   useEffect(() => {
//     setCustomerDetails(
//       JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details"))
//     );
//   }, []);

//   // useEffect(() => {
//   //   if (formConfigs) {
//   //     // Initialize form data with default values from form config
//   //     const initialData = {};
//   //     formConfigs.fields.forEach((field) => {
//   //       initialData[field.name] = field.defaultValue || "";
//   //     });
//   //     setFormData(initialData);
//   //   }
//   // }, [formConfigs]);

//   const handleChange = (e) => {
//     const { name, value, files, type, checked } = e.target;

//     if (type === "file") {
//       setFormData((prevData) => ({
//         ...prevData,
//         attachments: [...(prevData.attachments || []), ...Array.from(files)],
//       }));
//     } else if (type === "checkbox") {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: checked,
//       }));
//     } else {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     }
//   };

//   const handleDeleteAttachment = (index) => {
//     setFormData((prevData) => {
//       const newAttachments = [...prevData.attachments];
//       newAttachments.splice(index, 1);
//       return { ...prevData, attachments: newAttachments };
//     });
//   };

//   const token = localStorage.getItem("dexkor-chat-widget-auth-token");

//   useEffect(() => {
//     if (ticketId) {
//       onSubmit(formData);
//     }
//   }, [ticketId]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
//         {
//           uniquePartnerId: widgetConfigs.uniquePartnerId,
//           // customFields: formData,
//           subject: formData.subject,
//           description: formData.description,
//           module: "module005",
//           source: "widget",
//           email: customerDetails?.email || null,
//           cc: [
//             {
//               name: formData.name,
//               address: customerDetails?.email || formData?.email,
//             },
//           ],
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       setTicketId(response.data._id);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error occurred while submitting form:", error);
//       setLoading(false);
//     }
//   };

//   // useEffect(() => {
//   //   setIsFormConfigLoading(true);
//   //   const getTicketForm = async () => {
//   //     try {
//   //       const response = await axios.get(
//   //         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/widget/ticket-form/${widgetConfigs.uniquePartnerId}`
//   //       );
//   //       setFormConfigs(response?.data?.data);
//   //       setIsFormConfigLoading(false);
//   //     } catch (error) {
//   //       console.error("Error fetching form config:", error);
//   //       setIsFormConfigLoading(false);
//   //     }
//   //   };
//   //   getTicketForm();
//   // }, [widgetConfigs.uniquePartnerId]);

//   const renderField = (field) => {
//     const commonProps = {
//       id: field.name,
//       name: field.name,
//       value: formData[field.name] || "",
//       onChange: handleChange,
//       className: "dexkor-form-input",
//       required: field.required,
//       placeholder: field.label,
//     };

//     switch (field.fieldType) {
//       case "text":
//       case "email":
//       case "number":
//         return (
//           <input
//             type={field.fieldType}
//             {...commonProps}
//             minLength={field.validation?.min}
//             maxLength={field.validation?.max}
//           />
//         );

//       case "textarea":
//         return (
//           <textarea
//             {...commonProps}
//             className="dexkor-form-input-textarea"
//             rows={4}
//             minLength={field.validation?.min}
//             maxLength={field.validation?.max}
//           />
//         );

//       case "select":
//         return (
//           <select {...commonProps} className="dexkor-form-input py-1">
//             <option value="">
//               {field.defaultValue || `Select ${field.label}`}
//             </option>
//             {field.options.map((option) => (
//               <option key={option._id} value={option.value}>
//                 {option.label}
//               </option>
//             ))}
//           </select>
//         );

//       case "checkbox":
//         return (
//           <div className="flex items-center">
//             <input
//               type="checkbox"
//               {...commonProps}
//               checked={formData[field.name] || false}
//               className="mr-2"
//             />
//             <label>{field.label}</label>
//           </div>
//         );

//       case "date":
//         return <input type="date" {...commonProps} />;

//       default:
//         return null;
//     }
//   };

//   if (isFormConfigLoading) {
//     return (
//       <div>
//         <PageLoader />
//       </div>
//     );
//   }

//   if (!formConfigs) {
//     return <div>Unable to load form configuration</div>;
//   }

//   return (
//     <div className="p-2 mt-0 dexkor-scrollable-form">
//       <h2
//         className="dexkor-issue-header"
//         style={{ color: setupDetails?.widgetCustomizations.primaryColor }}
//       >
//         Create ticket
//       </h2>

//       <form className="space-y-5 mt-4" onSubmit={handleSubmit}>
//         <div className="dexkor-form-grid">
//           {/* Render dynamic fields */}
//           {formConfigs?.map((field) => (
//             <div key={field._id} className={`mb-2 dexkor-form-full-width`}>
//               <label className="flex items-start">{field?.label}</label>
//               {renderField(field)}
//             </div>
//           ))}

//           {/* Static attachments field */}
//           {/* <div className="mb-4 dexkor-form-full-width"> */}
//           {/* <div className="flex items-center justify-center w-full">
//               <label
//                 htmlFor="dropzone-file"
//                 className="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50"
//               >
//                 <div className="flex flex-col items-center justify-center pt-3 pb-4">
//                   <div className="flex items-center justify-center space-x-2">
//                     <svg
//                       className="w-5 h-5 mb-2 text-gray-500"
//                       aria-hidden="true"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 20 16"
//                     >
//                       <path
//                         stroke="currentColor"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
//                       />
//                     </svg>
//                     <p className="mb-2 text-sm text-gray-500">
//                       <span className="font-semibold">Click to upload</span>
//                     </p>
//                   </div>
//                   <p className="text-xs text-gray-500">
//                     SVG, PNG, JPG or PDF (MAX. 5mb)
//                   </p>
//                 </div>
//                 <input
//                   id="dropzone-file"
//                   type="file"
//                   name="attachments"
//                   onChange={handleChange}
//                   className="hidden"
//                   multiple
//                 />
//               </label>
//             </div> */}

//           {/* Display selected attachments */}
//           {/* <div className="mt-2">
//               {formData.attachments?.map((file, index) => (
//                 <div
//                   key={index}
//                   className="flex items-center justify-between mb-1"
//                 >
//                   <span className="text-sm text-gray-700">{file.name}</span>
//                   <button
//                     type="button"
//                     onClick={() => handleDeleteAttachment(index)}
//                     className="text-red-500 hover:text-red-700"
//                   >
//                     <IoTrashOutline className="h-5 w-5" />
//                   </button>
//                 </div>
//               ))}
//             </div> */}
//           {/* </div> */}
//         </div>
//         <div className="flex justify-end space-x-6">
//           {loading ? (
//             <IssueLoaderButton />
//           ) : (
//             <>
//               <button
//                 onClick={() => setShowForm(false)}
//                 className="dexkor-issue-cancel-button"
//                 style={{
//                   color: setupDetails?.widgetCustomizations.primaryColor,
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="dexkor-issue-submit-button"
//                 style={{
//                   background: setupDetails?.widgetCustomizations.primaryColor,
//                 }}
//               >
//                 Submit
//               </button>
//             </>
//           )}
//         </div>
//       </form>
//     </div>
//   );
// };

// export default IssueForm;

// import React, { useEffect, useState } from "react";

// import axios from "axios";

// import { IoTrashOutline, IoCloseOutline } from 'react-icons/io5';

// import "../CSS/IssueForm.css";
// import "../CSS/Message.css";

// import FormTemplate from "./FormTemplate";

// import IssueLoaderButton from "./pageLoaders/IssueLoaderButton";
// import PageLoader from "./pageLoaders/PageLoader";

// const IssueForm = ({
//   onSubmit,
//   setShowForm,
//   setTicketId,
//   ticketId,
//   loading,
//   setLoading,
//   widgetConfigs,
//   setupDetails,
// }) => {
//   const [formData, setFormData] = useState({
//     subject: '',
//     description: '',
//     attachments: []
//   });
//   const [customData, setCustomData] = useState({});
//   const [customerDetails, setCustomerDetails] = useState(null);

//   useEffect(() => {
//     const details = JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details"));
//     setCustomerDetails(details);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, files, type } = e.target;
//     if (type === "file") {
//       setFormData((prev) => ({
//         ...prev,
//         attachments: [...(prev.attachments || []), ...Array.from(files)],
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleDeleteAttachment = (index) => {
//     setFormData((prev) => {
//       const newAttachments = prev.attachments.filter((_, i) => i !== index);
//       return { ...prev, attachments: newAttachments };
//     });
//   };

//   const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2OTA1YmY2YmIxZWIyOTQ3YTc1ZTAwYzQiLCJ1bmlxdWVQYXJ0bmVySWQiOiI2NmY3ZDE2NjJlYTg2NTc0ZTA3MGM1MzYiLCJyb2xlIjoiQWRtaW4iLCJpYXQiOjE3NjY3NjIyMjYsImV4cCI6MTc2NzM2NzAyNn0.D0my8CppaEYhx-i4wU2TQDhW9PyjAUxFAys4tFuvnyg";

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const token = localStorage.getItem("dexkor-chat-widget-auth-token");

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
//         {
//           uniquePartnerId: widgetConfigs.uniquePartnerId,
//           subject: formData.subject,
//           description: formData.description,
//           module: "module005",
//           source: "widget",
//           email: customerDetails?.email || null,
//           // customFields: customData,
//           attachments: formData.attachments,
//           cc: [
//             {

//               address: customerDetails?.email,
//             },
//           ],
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setTicketId(response.data._id);
//       if (onSubmit) onSubmit(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error occurred while submitting form:", error);
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="absolute inset-0 z-50 bg-white rounded-lg flex flex-col">
//       {/* Fixed Header */}
//       <div className="px-2 py-1 border-b border-gray-200 bg-gray-50 flex-shrink-0">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => setShowForm(false)}
//               className="p-1.5 hover:bg-gray-200 rounded-md transition-colors"
//             >
//               <IoCloseOutline className="w-4 h-4 text-gray-600" />
//             </button>
//             <h2 className="text-base font-semibold text-gray-900">Create New Ticket</h2>
//             {/* <div>
//               <p className="text-xs text-gray-500 mt-0.5">
//                 Fill in the details to create a support ticket
//               </p>
//             </div> */}
//           </div>
//         </div>
//       </div>

//       {/* Scrollable Form Content */}
//       <div className="flex-1 overflow-hidden">
//         <div className="h-full rounded-lg">
//           <form onSubmit={handleSubmit} >
//             <div className="overflow-y-auto p-2 max-h-[380px]  dexkor-scrollbar space-y-2" >

//             {/* Subject Field */}
//             <div className="space-y-1.5">
//               <label className="block text-start text-sm font-medium text-gray-700">
//                 Subject <span className="text-red-500 ml-0.5">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="subject"
//                 value={formData.subject}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                 placeholder="Enter subject"
//                 required
//               />
//             </div>

//             {/* Description Field */}
//             <div className="space-y-1.5">
//               <label className="block text-sm text-start font-medium text-gray-700">
//                 Description <span className="text-red-500 ml-0.5">*</span>
//               </label>
//               <textarea
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
//                 rows={3}
//                 placeholder="Describe your issue"
//                 required
//               />
//             </div>

//             {/* Dynamic Custom Fields */}
//             <div className="">
//               <FormTemplate
//                 formType="ticket"
//                 formData={customData}
//                 setFormData={setCustomData}
//                 showPriority={true}
//                 token={token}
//               />
//             </div>

//             {/* Attachments */}
//             <div className="pt-2">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Attachments (Optional)
//               </label>
//               <div className="flex items-center justify-center w-full">
//                 <label className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
//                   <div className="flex flex-col items-center justify-center">
//                     <svg
//                       className="w-5 h-5 mb-1 text-gray-500"
//                       aria-hidden="true"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 20 16"
//                     >
//                       <path
//                         stroke="currentColor"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
//                       />
//                     </svg>
//                     <p className="text-xs text-gray-500">
//                       <span className="font-medium">Click to upload</span>
//                     </p>
//                     <p className="text-xs text-gray-400">Max 5MB per file</p>
//                   </div>
//                   <input
//                     type="file"
//                     className="hidden"
//                     multiple
//                     onChange={handleChange}
//                   />
//                 </label>
//               </div>

//               {/* Display selected attachments */}
//               {formData.attachments?.length > 0 && (
//                 <div className="mt-3 space-y-1.5">
//                   {formData.attachments.map((file, index) => (
//                     <div key={index} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-md">
//                       <div className="flex items-center space-x-2">
//                         <div className="w-6 h-6 flex items-center justify-center bg-blue-100 rounded">
//                           <span className="text-xs font-medium text-blue-600">
//                             {file.name.split('.').pop()?.charAt(0).toUpperCase()}
//                           </span>
//                         </div>
//                         <div className="min-w-0">
//                           <p className="text-xs font-medium text-gray-700 truncate max-w-[180px]">
//                             {file.name}
//                           </p>
//                           <p className="text-xs text-gray-500">
//                             {(file.size / 1024 / 1024).toFixed(2)} MB
//                           </p>
//                         </div>
//                       </div>
//                       <button
//                         type="button"
//                         onClick={() => handleDeleteAttachment(index)}
//                         className="text-red-500 hover:text-red-700 p-0.5"
//                       >
//                         <IoTrashOutline className="w-4 h-4" />
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             </div>

//             {/* Form Actions - Fixed at bottom */}
//             <div className="pt-4 border-t border-gray-200">
//               <div className="flex justify-end space-x-3">
//                 <button
//                   type="button"
//                   onClick={() => setShowForm(false)}
//                   className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                   style={{
//                     background: setupDetails?.widgetCustomizations?.primaryColor || "#4F46E5",
//                   }}
//                 >
//                   {loading ? (
//                     <span className="flex items-center gap-1.5">
//                       <IssueLoaderButton />
//                       Creating...
//                     </span>
//                   ) : (
//                     "Create Ticket"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default IssueForm;

// import React, { useEffect, useState } from "react";

// import axios from "axios";

// import { IoTrashOutline, IoCloseOutline } from 'react-icons/io5';

// import "../CSS/IssueForm.css";
// import "../CSS/Message.css";

// import FormTemplate from "./FormTemplate";

// import IssueLoaderButton from "./pageLoaders/IssueLoaderButton";
// import PageLoader from "./pageLoaders/PageLoader";

// const IssueForm = ({
//   onSubmit,
//   setShowForm,
//   setTicketId,
//   ticketId,
//   loading,
//   setLoading,
//   widgetConfigs,
//   setupDetails,
// }) => {
//   const [formData, setFormData] = useState({
//     subject: '',
//     description: '',
//     attachments: []
//   });
//   const [customData, setCustomData] = useState({});
//   const [customerDetails, setCustomerDetails] = useState(null);

//   useEffect(() => {
//     const details = JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details"));
//     setCustomerDetails(details);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, files, type } = e.target;
//     if (type === "file") {
//       setFormData((prev) => ({
//         ...prev,
//         attachments: [...(prev.attachments || []), ...Array.from(files)],
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleDeleteAttachment = (index) => {
//     setFormData((prev) => {
//       const newAttachments = prev.attachments.filter((_, i) => i !== index);
//       return { ...prev, attachments: newAttachments };
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Get token from localStorage - FIXED: removed hardcoded token shadowing
//     const token = localStorage.getItem("dexkor-chat-widget-auth-token");

//     // Log the form data for debugging
//     console.log("Form data being submitted:", {
//       subject: formData.subject,
//       description: formData.description,
//       customData: customData
//     });

//     try {
//       // Prepare payload exactly like old working version
//       const payload = {
//         uniquePartnerId: widgetConfigs.uniquePartnerId,
//         subject: formData.subject,
//         description: formData.description,
//         module: "module005",
//         source: "widget",
//         email: customerDetails?.email || null,
//         // Do NOT include customData unless it has actual values
//         // Do NOT include attachments array if empty
//         cc: [
//           {
//             name: customerDetails?.name || "Customer", // Add name field back
//             address: customerDetails?.email,
//           },
//         ],
//       };

//       // Only add customFields if customData has values
//       if (customData && Object.keys(customData).length > 0) {
//         // Clean customData - remove empty values
//         const cleanedCustomData = {};
//         Object.keys(customData).forEach(key => {
//           if (customData[key] !== '' && customData[key] !== null && customData[key] !== undefined) {
//             cleanedCustomData[key] = customData[key];
//           }
//         });

//         if (Object.keys(cleanedCustomData).length > 0) {
//           payload.customFields = cleanedCustomData;
//         }
//       }

//       // Only add attachments if there are any
//       if (formData.attachments && formData.attachments.length > 0) {
//         payload.attachments = formData.attachments;
//       }

//       console.log("Final payload being sent:", JSON.stringify(payload, null, 2));

//       const response = await axios.post(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json", // Explicitly set content type
//           },
//         }
//       );

//       console.log("Response received:", response.data);

//       setTicketId(response.data._id);

//       // Call onSubmit with the response data
//       if (onSubmit) {
//         onSubmit(response.data);
//       }

//       setLoading(false);

//       // Close the form after successful submission
//       setShowForm(false);

//     } catch (error) {
//       console.error("Error occurred while submitting form:", error);
//       console.error("Error response:", error.response?.data);
//       console.error("Error status:", error.response?.status);

//       // Try without any custom fields if error persists
//       if (error.response?.status === 500 || error.response?.status === 400) {
//         console.log("Retrying with minimal payload...");

//         try {
//           const minimalPayload = {
//             uniquePartnerId: widgetConfigs.uniquePartnerId,
//             subject: formData.subject || "Test Subject",
//             description: formData.description || "Test Description",
//             module: "module005",
//             source: "widget",
//             email: customerDetails?.email || null,
//             cc: [{
//               address: customerDetails?.email || "test@example.com"
//             }],
//           };

//           const retryResponse = await axios.post(
//             `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
//             minimalPayload,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json",
//               },
//             }
//           );

//           console.log("Retry successful:", retryResponse.data);
//           setTicketId(retryResponse.data._id);
//           if (onSubmit) onSubmit(retryResponse.data);
//           setLoading(false);
//           setShowForm(false);
//           return;
//         } catch (retryError) {
//           console.error("Retry also failed:", retryError);
//         }
//       }

//       setLoading(false);
//     }
//   };

//   return (
//     <div className="absolute inset-0 z-50 bg-white rounded-lg flex flex-col">
//       {/* Fixed Header */}
//       <div className="px-2 py-1 border-b border-gray-200 bg-gray-50 flex-shrink-0">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => setShowForm(false)}
//               className="p-1.5 hover:bg-gray-200 rounded-md transition-colors"
//             >
//               <IoCloseOutline className="w-4 h-4 text-gray-600" />
//             </button>
//             <h2 className="text-base font-semibold text-gray-900">Create New Ticket</h2>
//           </div>
//         </div>
//       </div>

//       {/* Scrollable Form Content */}
//       <div className="flex-1 overflow-hidden">
//         <div className="h-full rounded-lg">
//           <form onSubmit={handleSubmit}>
//             <div className="overflow-y-auto p-2 max-h-[380px] dexkor-scrollbar space-y-2">
//               {/* Subject Field */}
//               <div className="space-y-1.5">
//                 <label className="block text-start text-sm font-medium text-gray-700">
//                   Subject <span className="text-red-500 ml-0.5">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="subject"
//                   value={formData.subject}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="Enter subject"
//                   required
//                 />
//               </div>

//               {/* Description Field */}
//               <div className="space-y-1.5">
//                 <label className="block text-sm text-start font-medium text-gray-700">
//                   Description <span className="text-red-500 ml-0.5">*</span>
//                 </label>
//                 <textarea
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
//                   rows={3}
//                   placeholder="Describe your issue"
//                   required
//                 />
//               </div>

//               {/* Dynamic Custom Fields */}
//               <div className="">
//                 <FormTemplate
//                   formType="ticket"
//                   formData={customData}
//                   setFormData={setCustomData}
//                   showPriority={true}
//                    token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2OTA1YmY2YmIxZWIyOTQ3YTc1ZTAwYzQiLCJ1bmlxdWVQYXJ0bmVySWQiOiI2NmY3ZDE2NjJlYTg2NTc0ZTA3MGM1MzYiLCJyb2xlIjoiQWRtaW4iLCJpYXQiOjE3NjY3NjIyMjYsImV4cCI6MTc2NzM2NzAyNn0.D0my8CppaEYhx-i4wU2TQDhW9PyjAUxFAys4tFuvnyg"

//                   // token={localStorage.getItem("dexkor-chat-widget-auth-token")} // Pass token as prop
//                 />
//               </div>

//               {/* Attachments */}
//               <div className="pt-2">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Attachments (Optional)
//                 </label>
//                 <div className="flex items-center justify-center w-full">
//                   <label className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
//                     <div className="flex flex-col items-center justify-center">
//                       <svg
//                         className="w-5 h-5 mb-1 text-gray-500"
//                         aria-hidden="true"
//                         xmlns="http://www.w3.org/2000/svg"
//                         fill="none"
//                         viewBox="0 0 20 16"
//                       >
//                         <path
//                           stroke="currentColor"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
//                         />
//                       </svg>
//                       <p className="text-xs text-gray-500">
//                         <span className="font-medium">Click to upload</span>
//                       </p>
//                       <p className="text-xs text-gray-400">Max 5MB per file</p>
//                     </div>
//                     <input
//                       type="file"
//                       className="hidden"
//                       multiple
//                       onChange={handleChange}
//                     />
//                   </label>
//                 </div>

//                 {/* Display selected attachments */}
//                 {formData.attachments?.length > 0 && (
//                   <div className="mt-3 space-y-1.5">
//                     {formData.attachments.map((file, index) => (
//                       <div key={index} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-md">
//                         <div className="flex items-center space-x-2">
//                           <div className="w-6 h-6 flex items-center justify-center bg-blue-100 rounded">
//                             <span className="text-xs font-medium text-blue-600">
//                               {file.name.split('.').pop()?.charAt(0).toUpperCase()}
//                             </span>
//                           </div>
//                           <div className="min-w-0">
//                             <p className="text-xs font-medium text-gray-700 truncate max-w-[180px]">
//                               {file.name}
//                             </p>
//                             <p className="text-xs text-gray-500">
//                               {(file.size / 1024 / 1024).toFixed(2)} MB
//                             </p>
//                           </div>
//                         </div>
//                         <button
//                           type="button"
//                           onClick={() => handleDeleteAttachment(index)}
//                           className="text-red-500 hover:text-red-700 p-0.5"
//                         >
//                           <IoTrashOutline className="w-4 h-4" />
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Form Actions - Fixed at bottom */}
//             <div className="pt-4 border-t border-gray-200">
//               <div className="flex justify-end space-x-3">
//                 <button
//                   type="button"
//                   onClick={() => setShowForm(false)}
//                   className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                   style={{
//                     background: setupDetails?.widgetCustomizations?.primaryColor || "#4F46E5",
//                   }}
//                 >
//                   {loading ? (
//                     <span className="flex items-center gap-1.5">
//                       <IssueLoaderButton />
//                       Creating...
//                     </span>
//                   ) : (
//                     "Create Ticket"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default IssueForm;

import React, { useEffect, useState } from "react";

import axios from "axios";

import { IoTrashOutline, IoCloseOutline } from "react-icons/io5";
import { ChevronLeft, X, Maximize2, Minimize2 } from "lucide-react";

import "../CSS/IssueForm.css";
import "../CSS/Message.css";

import FormTemplate from "./FormTemplate";

import IssueLoaderButton from "./pageLoaders/IssueLoaderButton";
import PageLoader from "./pageLoaders/PageLoader";

const IssueForm = ({
  onSubmit,
  setShowForm,
  setTicketId,
  ticketId,
  loading,
  setLoading,
  widgetConfigs,
  setupDetails,
  isExpanded,
  setIsExpanded,
  setIsOpen,
}) => {
  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    attachments: [],
  });
  const [customData, setCustomData] = useState({});
  const [customerDetails, setCustomerDetails] = useState(null);

  useEffect(() => {
    const details = JSON.parse(
      localStorage.getItem("dexkor-chat-widget-customer-details")
    );
    setCustomerDetails(details);
  }, []);

  // THIS WAS MISSING - Critical for navigation after ticket creation
  useEffect(() => {
    if (ticketId) {
      onSubmit({ ...formData, ...customData });
    }
  }, [ticketId]);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        attachments: [...(prev.attachments || []), ...Array.from(files)],
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDeleteAttachment = (index) => {
    setFormData((prev) => {
      const newAttachments = prev.attachments.filter((_, i) => i !== index);
      return { ...prev, attachments: newAttachments };
    });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const token = localStorage.getItem("dexkor-chat-widget-auth-token");

  //   try {
  //     // Prepare the request payload
  //     const payload = {
  //       uniquePartnerId: widgetConfigs.uniquePartnerId,
  //       createdBy: widgetConfigs?.userId,
  //       customerCode:widgetConfigs?.customerCode || null,
  //       number: widgetConfigs?.userNumber || null,
  //       name:widgetConfigs?.userName || null,
  //       subject: formData.subject,
  //       description: formData.description,
  //       module: "module005",
  //       source: "widget",
  //       email: customerDetails?.email || null,
  //       customFields: customData, // Include custom fields
  //       cc: [
  //         {
  //           name: customerDetails?.name || widgetConfigs?.userName,
  //           address: customerDetails?.email || widgetConfigs?.userEmail || widgetConfigs?.email,
  //         },
  //       ],
  //     };

  //     // If there are attachments, use FormData
  //     let requestData;
  //     let headers = {
  //       Authorization: `Bearer ${token}`,
  //     };

  //     if (formData.attachments && formData.attachments.length > 0) {
  //       requestData = new FormData();

  //       // Append all fields
  //       Object.keys(payload).forEach((key) => {
  //         if (key === "cc" || key === "customFields") {
  //           requestData.append(key, JSON.stringify(payload[key]));
  //         } else {
  //           requestData.append(key, payload[key]);
  //         }
  //       });

  //       // Append attachments
  //       formData.attachments.forEach((file) => {
  //         requestData.append("attachments", file);
  //       });

  //       headers["Content-Type"] = "multipart/form-data";
  //     } else {
  //       requestData = payload;
  //     }

  //     const response = await axios.post(
  //       `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
  //       requestData,
  //       { headers }
  //     );

  //     setTicketId(response.data._id);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error occurred while submitting form:", error);
  //     console.error("Error response:", error.response?.data);
  //     setLoading(false);
  //   }
  // };
  
  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  const token = localStorage.getItem("dexkor-chat-widget-auth-token");

  try {
    // 1. Upload Attachments to S3 first if any exist

       
    let uploadedAttachments = [];
    if (formData.attachments && formData.attachments.length > 0) {
      // Use Promise.all to upload all files in parallel
      const uploadPromises = formData.attachments.map(async (file) => {
        const fileFormData = new FormData();
        fileFormData.append('attachment', file);
        
        const res = await fetch(`${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/attachment`, {
          method: 'POST',
          body: fileFormData,
          // headers: { Authorization: `Bearer ${token}` } // Add if your upload API requires it
        });

        if (!res.ok) throw new Error('File upload failed');
        const result = await res.json();
        
        // Return the structure expected by your backend
        return {
          url: result.data.url,
          filename: result.data.filename,
          type: result.data.type,
          size: result.data.size,
        };
      });

      uploadedAttachments = await Promise.all(uploadPromises);
    }

    // 2. Prepare the standard JSON payload
    const payload = {
      uniquePartnerId: widgetConfigs.uniquePartnerId,
      createdBy: widgetConfigs?.userId,
      customerCode: widgetConfigs?.customerCode || null,
      number: widgetConfigs?.userNumber || null,
      name: widgetConfigs?.userName || null,
      subject: formData.subject,
      description: formData.description,
      module: "module005",
      source: "widget",
      email: customerDetails?.email || null,
      customFields: customData,
      attachments: uploadedAttachments,
      widget_web_url: window.location.href,
      messages: [
        {
          sender: "Customer",
          fromAddress: customerDetails?.email || widgetConfigs?.userEmail || widgetConfigs?.email,
          message: formData.description,
          attachmentType: "image/jpeg",
          attachments: uploadedAttachments.map((attachment) => ({
            filename: attachment.filename,
            url: attachment.url,
            type: attachment.type,
            size: attachment.size,
          })),
        }
      ],
       // Send the array of URLs and metadata
      cc: [
        {
          name: customerDetails?.name || widgetConfigs?.userName,
          address: customerDetails?.email || widgetConfigs?.userEmail || widgetConfigs?.email,
        },
      ],
    };

    // 3. Post as standard JSON (no FormData needed anymore)
    const response = await axios.post(
      `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setTicketId(response.data._id);

    setLoading(false);
  } catch (error) {
    console.error("Error occurred while submitting form:", error);
    setLoading(false);
  }
};

 return (
    <div className="w-full h-full flex-1 min-h-0 bg-white flex flex-col overflow-hidden">
      {/* --- Gleap White Top Header (54px) --- */}
      <div className="flex items-center justify-between px-4 h-14 border-b border-slate-100 shrink-0 bg-white sticky top-0 z-10">
        <button
          onClick={() => setShowForm(false)}
          className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
          title="Back to tickets"
        >
          <ChevronLeft className="w-5 h-5 stroke-[2.2]" />
        </button>

        <div className="font-bold text-slate-900 text-sm tracking-tight text-center truncate px-2 flex-1">
          Create New Ticket
        </div>

        <div className="flex items-center gap-1 min-w-[32px] justify-end">
          {setIsExpanded && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
              title={isExpanded ? "Collapse" : "Expand"}
            >
              {isExpanded ? (
                <Minimize2 className="w-4 h-4 text-slate-500 hover:text-slate-800" />
              ) : (
                <Maximize2 className="w-4 h-4 text-slate-500 hover:text-slate-800" />
              )}
            </button>
          )}
          <button
            onClick={() => {
              if (setIsOpen) setIsOpen(false);
              else setShowForm(false);
            }}
            className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
            title="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Form with Scrollable Content and Fixed Footer */}
      <form
        onSubmit={handleSubmit}
        className="flex-1 flex flex-col overflow-hidden"
      >
        {/* Scrollable Form Content */}
        <div className="flex-1 overflow-y-auto p-2 sm:p-5 space-y-2 dexkor-scrollbar bg-slate-50/40">
          {/* Card 1: Main Fields */}
          <div className="bg-white rounded-2xl p-2 border border-slate-200/80 shadow-sm space-y-3.5">
            {/* Subject Field */}
            <div className="space-y-1">
              <label className="block text-start text-xs font-bold text-slate-700">
                Subject <span className="text-rose-500">*</span>
              </label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="w-full px-3.5 py-2.5 bg-slate-50 hover:bg-slate-100/60 focus:bg-white border border-slate-200 focus:border-slate-400 rounded-xl text-xs sm:text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-900/5 transition-all"
                placeholder="What is the issue regarding?"
                required
              />
            </div>

            {/* Description Field */}
            <div className="space-y-1">
              <label className="block text-start text-xs font-bold text-slate-700">
                Description <span className="text-rose-500">*</span>
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="w-full px-3.5 py-2.5 bg-slate-50 hover:bg-slate-100/60 focus:bg-white border border-slate-200 focus:border-slate-400 rounded-xl text-xs sm:text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-900/5 transition-all resize-none min-h-[95px] leading-relaxed"
                rows={3}
                placeholder="Please describe what you are experiencing in detail..."
                required
              />
            </div>
          </div>

          {/* Card 2: Dynamic Custom Fields (if any) */}
          <div className="bg-white rounded-2xl p-2 border border-slate-200/80 shadow-sm empty:hidden">
            <FormTemplate
              formType="ticket"
              formData={customData}
              setFormData={setCustomData}
              showPriority={false}
              token={widgetConfigs?.token}
              uniquePartnerId={
                widgetConfigs?.application
                  ? widgetConfigs.dexkorId
                  : widgetConfigs.uniquePartnerId
              }
            />
          </div>

          {/* Card 3: Attachments */}
          <div className="bg-white rounded-2xl p-2 border border-slate-200/80 shadow-sm space-y-3">
            <div className="flex items-center justify-between">
              <label className="block text-start text-xs font-bold text-slate-700">
                Attachments <span className="text-slate-400 font-normal">(Optional)</span>
              </label>
              <span className="text-[11px] text-slate-400">Max 10MB</span>
            </div>

            <div className="flex items-center justify-center w-full">
              <label className="flex flex-col items-center justify-center w-full py-4 px-3 border-2 border-slate-200 border-dashed rounded-xl cursor-pointer bg-slate-50/60 hover:bg-slate-50 hover:border-slate-300 transition-colors group">
                <div className="flex flex-col items-center justify-center text-center">
                  <svg
                    className="w-6 h-6 mb-1.5 text-slate-400 group-hover:text-slate-600 transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.75}
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                    />
                  </svg>
                  <p className="text-xs font-semibold text-slate-700">
                    Click to upload or drag & drop
                  </p>
                  <p className="text-[10px] text-slate-400 mt-0.5">PNG, JPG, PDF, or DOCX</p>
                </div>
                <input
                  type="file"
                  className="hidden"
                  multiple
                  onChange={handleChange}
                />
              </label>
            </div>

            {/* Display selected attachments */}
            {formData.attachments?.length > 0 && (
              <div className="space-y-1.5 pt-1">
                {formData.attachments.map((file, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between bg-slate-50 border border-slate-200/80 px-3 py-2 rounded-xl"
                  >
                    <div className="flex items-center space-x-2.5 min-w-0 flex-1 pr-2">
                      <div className="w-7 h-7 flex items-center justify-center bg-indigo-50 border border-indigo-100 rounded-lg shrink-0">
                        <span className="text-[10px] font-bold text-indigo-600 uppercase">
                          {file.name.split(".").pop()?.substring(0, 3)}
                        </span>
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="text-xs font-semibold text-slate-800 truncate">
                          {file.name}
                        </p>
                        <p className="text-[10px] text-slate-400">
                          {(file.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => handleDeleteAttachment(index)}
                      className="w-7 h-7 rounded-lg flex items-center justify-center text-slate-400 hover:text-rose-600 hover:bg-rose-50 transition-colors border-none bg-transparent cursor-pointer shrink-0"
                      title="Remove file"
                    >
                      <IoTrashOutline className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Form Actions - Fixed at bottom */}
        <div className="p-3.5 px-4 sm:px-5 border-t border-slate-100 flex-shrink-0 bg-white flex items-center justify-end gap-3 shadow-[0_-4px_12px_rgba(0,0,0,0.03)]">
          <button
            type="button"
            onClick={() => setShowForm(false)}
            className="px-4 py-2 text-xs sm:text-sm font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200/80 rounded-xl transition-all border-none cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-5 py-2 text-xs sm:text-sm font-bold text-white rounded-xl shadow-sm hover:opacity-95 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed transition-all border-none cursor-pointer"
            style={{
              background:
                setupDetails?.widgetCustomizations?.uiColor ||
                setupDetails?.widgetCustomizations?.color1 ||
                setupDetails?.widgetCustomizations?.primaryColor ||
                "#000000",
            }}
          >
            {loading ? (
              <span className="flex items-center gap-1.5">
                Creating...
              </span>
            ) : (
              "Create Ticket"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default IssueForm;
